<template>
    <div>
      <span class="text-blue-600 text-xl" >{{ title }}</span>
      <pre class="text-xs">{{ valueString }}</pre>
    </div>
  </template>
  <script lang="ts">
  const props = {
    title: {
      required: true,
      type: String
    },
    value: {
      required: true
    }
  };
  export default {
    props,
    computed: {
      valueString() {
        return JSON.stringify(this.value, null, 2);
      }
    }
  };
  </script>
  <style scoped>
  pre {
    text-align: start;
  }
  </style>